// 
import { observer } from "mobx-react-lite"
import React, { FC, useCallback, useEffect, useReducer, useRef, useState } from "react"
import { ImageStyle, Platform, ScrollView, TextStyle, ViewStyle, SafeAreaView, FlatList, Alert, Dimensions, RefreshControl, ActivityIndicator } from "react-native"
import { api } from "../../../../../../services/api"
import { colors, spacing } from "../../../../../../theme"
import { View, Text, TextField, Card, Checkbox, DateTimePicker, Picker, SegmentedControl, Assets, Spacings, Colors, BorderRadiuses, Timeline, GridList, GridView, Modal, SortableList, SortableGridList, Image, Button, TabController, Avatar, TouchableOpacity, Carousel as UICarousel, } from 'react-native-ui-lib';
import DynamicForm, { Col, CustomModal, CustomNumberInput, CustomSelect, DangerButton, Heading, Row, SecondaryButton, CustomTextField, Label, CustomCheckbox } from "../../../../../../mycomponents/DynamicForm"
import DynamicTable from "../../../../../../mycomponents/DynamicTable"
import { useNavigate, useParams } from "react-router-dom"
import { useStores } from "../../../../../../mycomponents/state"
import { useNavigationState, useNavigation } from "@react-navigation/native"
import LayoutScreen from "../../../../../../mycomponents/CRUD/LayoutScreen"
import FormScreen from "../../../../../../mycomponents/CRUD/FormScreen"
import {
    LineChart,
    BarChart,
    PieChart,
    ProgressChart,
    ContributionGraph,
    StackedBarChart
} from "react-native-chart-kit";
import { QueryBuilder } from 'react-querybuilder';
import { QueryBuilderNative } from '@react-querybuilder/native';
import { App } from 'antd';
import { Agenda, DateData, AgendaEntry, AgendaSchedule, CalendarList } from 'react-native-calendars';
import { LinearGradient } from "expo-linear-gradient"
import { GlobalMasterStore } from "../../../../../../mycomponents/state/PermissionStore"
import { Icon } from "react-native-eva-icons"
import { MainScannerScreenComponent } from "../../../../../../mycomponents/CRUD/ListingScreen"
import * as Location from 'expo-location';
import { FlashList } from "@shopify/flash-list"
import dayjs from "dayjs"
import { Camera, CameraType } from 'expo-camera';
import Svg, { G, Path } from "react-native-svg"
import Header from "../Header"
import Shop from "../Shop"
import Footer from "../Footer"

import Animated, {
    interpolate,
    interpolateColor,
    useAnimatedStyle,
} from "react-native-reanimated";
import Carousel from "react-native-reanimated-carousel";
import { LongPressGestureHandler } from "react-native-gesture-handler"

const PAGE_WIDTH = Dimensions.get("window").width;

const boxIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <Path
            fill="#080341"
            fillRule="evenodd"
            d="m12 3.663 8.25 4.077v9.27L12 21.086 3.75 17.01V7.74L12 3.663Zm-6.75 5.75v6.665l6 2.965v-6.665l-6-2.965Zm7.5 2.965v6.665l6-2.965V9.413l-2.25 1.112V13.5l-1.5.75v-2.984l-2.25 1.112Zm5.057-4.172-1.954.965a.75.75 0 0 0-.142-.092L10.1 6.275 12 5.336l5.807 2.87ZM8.415 7.108l5.772 2.886L12 11.075l-5.807-2.87 2.222-1.097Z"
            clipRule="evenodd"
        />
    </Svg>
)

const paymentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        fill="none"
        viewBox="-0.5 0 25 25"
        {...props}
    >
        <Path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M18.92 7.97c.058-.387.085-.778.08-1.17a12.49 12.49 0 0 0-18 0c0 14.06 9 16.17 9 16.17a13.574 13.574 0 0 0 1.92-1M23 13.97H13"
        />
        <Path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M21 10.92h-6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2Z"
        />
    </Svg>
)

const returnIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        fill="none"
        viewBox="0 0 48 48"
        {...props}
    >
        <Path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={4}
            d="m13 8-7 6 7 7"
        />
        <Path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={4}
            d="M6 14h22.994c6.883 0 12.728 5.62 12.996 12.5.284 7.27-5.723 13.5-12.996 13.5H11.998"
        />
    </Svg>
)

const supportIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <Path
            stroke="#1C274C"
            strokeLinecap="round"
            strokeWidth={1.5}
            d="M8 9h8M8 12.5h5.5"
        />
        <Path
            fill="#1C274C"
            d="m13.087 21.388.645.382-.645-.382Zm.542-.916-.646-.382.646.382Zm-3.258 0-.645.382.645-.382Zm.542.916.646-.382-.646.382ZM1.25 10.5a.75.75 0 0 0 1.5 0h-1.5Zm1.824 5.126a.75.75 0 0 0-1.386.574l1.386-.574Zm4.716 3.365-.013.75.013-.75Zm-2.703-.372-.287.693.287-.693Zm16.532-2.706.693.287-.693-.287Zm-5.409 3.078-.012-.75.012.75Zm2.703-.372.287.693-.287-.693Zm.7-15.882-.392.64.392-.64Zm1.65 1.65.64-.391-.64.392ZM4.388 2.738l-.392-.64.392.64Zm-1.651 1.65-.64-.391.64.392ZM9.403 19.21l.377-.649-.377.649Zm4.33 2.56.541-.916-1.29-.764-.543.916 1.291.764Zm-4.007-.916.542.916 1.29-.764-.541-.916-1.291.764Zm2.715.152a.52.52 0 0 1-.882 0l-1.291.764c.773 1.307 2.69 1.307 3.464 0l-1.29-.764ZM10.5 2.75h3v-1.5h-3v1.5Zm10.75 7.75v1h1.5v-1h-1.5ZM7.803 18.242c-1.256-.022-1.914-.102-2.43-.316L4.8 19.313c.805.334 1.721.408 2.977.43l.026-1.5ZM1.688 16.2A5.75 5.75 0 0 0 4.8 19.312l.574-1.386a4.25 4.25 0 0 1-2.3-2.3l-1.386.574Zm19.562-4.7c0 1.175 0 2.019-.046 2.685-.045.659-.131 1.089-.277 1.441l1.385.574c.235-.566.338-1.178.389-1.913.05-.729.049-1.632.049-2.787h-1.5Zm-5.027 8.241c1.256-.021 2.172-.095 2.977-.429l-.574-1.386c-.515.214-1.173.294-2.428.316l.025 1.5Zm4.704-4.115a4.25 4.25 0 0 1-2.3 2.3l.573 1.386a5.75 5.75 0 0 0 3.112-3.112l-1.386-.574ZM13.5 2.75c1.651 0 2.837 0 3.762.089.914.087 1.495.253 1.959.537l.783-1.279c-.739-.452-1.577-.654-2.6-.752-1.012-.096-2.282-.095-3.904-.095v1.5Zm9.25 7.75c0-1.622 0-2.891-.096-3.904-.097-1.023-.299-1.862-.751-2.6l-1.28.783c.285.464.451 1.045.538 1.96.088.924.089 2.11.089 3.761h1.5Zm-3.53-7.124a4.25 4.25 0 0 1 1.404 1.403l1.279-.783a5.75 5.75 0 0 0-1.899-1.899l-.783 1.28ZM10.5 1.25c-1.622 0-2.891 0-3.904.095-1.023.098-1.862.3-2.6.752l.783 1.28c.464-.285 1.045-.451 1.96-.538.924-.088 2.11-.089 3.761-.089v-1.5ZM2.75 10.5c0-1.651 0-2.837.089-3.762.087-.914.253-1.495.537-1.959l-1.279-.783c-.452.738-.654 1.577-.752 2.6C1.25 7.61 1.25 8.878 1.25 10.5h1.5Zm1.246-8.403a5.75 5.75 0 0 0-1.899 1.899l1.28.783a4.25 4.25 0 0 1 1.402-1.403l-.783-1.279Zm7.02 17.993c-.202-.343-.38-.646-.554-.884a2.229 2.229 0 0 0-.682-.645l-.754 1.297c.047.028.112.078.224.232.121.166.258.396.476.764l1.29-.764Zm-3.24-.349c.44.008.718.014.93.037.198.022.275.054.32.08l.754-1.297c-.293-.17-.598-.24-.909-.274-.298-.033-.657-.038-1.069-.045l-.025 1.5Zm6.498 1.113c.218-.367.355-.598.476-.764.112-.154.177-.204.224-.232l-.754-1.297c-.29.17-.5.395-.682.645-.173.238-.352.54-.555.884l1.291.764Zm1.924-2.612c-.412.007-.771.012-1.069.045-.311.035-.616.104-.909.274l.754 1.297c.045-.026.122-.058.32-.08.212-.023.49-.03.93-.037l-.026-1.5Z"
        />
    </Svg>
)

const cartIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#000000"
        height="18px"
        width="18px"
        version="1.1"
        id="Capa_1"
        viewBox="0 0 483.1 483.1"
        {...props}
    >
        <G>
            <path d="M434.55,418.7l-27.8-313.3c-0.5-6.2-5.7-10.9-12-10.9h-58.6c-0.1-52.1-42.5-94.5-94.6-94.5s-94.5,42.4-94.6,94.5h-58.6   c-6.2,0-11.4,4.7-12,10.9l-27.8,313.3c0,0.4,0,0.7,0,1.1c0,34.9,32.1,63.3,71.5,63.3h243c39.4,0,71.5-28.4,71.5-63.3   C434.55,419.4,434.55,419.1,434.55,418.7z M241.55,24c38.9,0,70.5,31.6,70.6,70.5h-141.2C171.05,55.6,202.65,24,241.55,24z    M363.05,459h-243c-26,0-47.2-17.3-47.5-38.8l26.8-301.7h47.6v42.1c0,6.6,5.4,12,12,12s12-5.4,12-12v-42.1h141.2v42.1   c0,6.6,5.4,12,12,12s12-5.4,12-12v-42.1h47.6l26.8,301.8C410.25,441.7,389.05,459,363.05,459z" />
        </G>
    </Svg>
)

const isDesktop = Dimensions.get('window').width >= 768;

const Home = observer(function Home(props) {
    const permissions = GlobalMasterStore((state) => state.permissions);
    const employee = GlobalMasterStore((state) => state.employee);
    const [primaryColor, setPrimaryColor] = useState("#cab78d");

    const { message } = App.useApp();

    let navigation = useNavigation();
    let navigate = null;

    if (Platform.OS === 'web') {
        navigate = useNavigate();
    }

    const navigationFn = (path, params) => {
        if (Platform.OS === 'web') {
            let paramsString = "";
            if (params) {
                paramsString = "?" + Object.keys(params).map(key => key + '=' + params[key]).join('&');
            }
            navigate("/" + path + paramsString);
        } else {
            if (path.includes("report/")) {
                navigation.navigate("report", {
                    ...params,
                    name: path.replace("report/", ""),
                });
            } else {
                navigation.navigate(path, params);
            }
        }
    };

    const MainWrapper = useCallback(({ children }) => {
        return !props.hideWrapper ? <>
            <LayoutScreen>
                {isDesktop && <View marginT-2 style={{
                    flex: 1,
                    // backgroundColor: 'red'
                }} padding-20>
                    <Card padding-10>
                        {children}
                    </Card>
                </View>}

                {Platform.OS != 'web' && <View marginT-2 style={{
                    flex: 1,
                }} padding-10>
                    {children}
                </View>}

            </LayoutScreen>
        </> : <>
            {children}
        </>
    }, [])

    const [products, setProducts] = useState([]);

    const getProducts = async () => {
        const response = await api.customRoute("shop/getProducts", {
            page: 1,
            perPage: 8,
        });
        setProducts(response.data.data);
    };

    useEffect(() => {
        getProducts();
    }, []);

    const animationStyle = React.useCallback((value) => {
        "worklet";

        const zIndex = interpolate(value, [-1, 0, 1], [10, 20, 30]);
        const translateX = interpolate(
            value,
            [-2, 0, 1],
            [-PAGE_WIDTH, 0, PAGE_WIDTH],
        );

        return {
            transform: [{ translateX }],
            zIndex,
        };
    }, []);

    return (<>
        <ScrollView style={{
            height: Dimensions.get("window").height,
        }}>
            <Card style={{
                padding: 0,
            }}>
                <View marginB-0 style={{ borderRadius: 10, borderBottomEndRadius: 0, borderBottomStartRadius: 0 }}>

                    <View style={{
                        position: 'relative',
                    }}>
                        <Header />
                        <View style={{ flex: 1, position: 'relative' }}>
                            <Carousel
                                loop={true}
                                autoPlay={true}
                                autoPlayInterval={5000}
                                style={{ width: PAGE_WIDTH, height: isDesktop ? Dimensions.get("window").height : 500 }}
                                width={PAGE_WIDTH}
                                data={[{
                                    title: "IKAKI",
                                    sub_title: `We are situated in Bhopal, which is the birthplace of our founder, Apurvi Vyas. She believed that every individual is ikaki (one of a kind), and that is why her vision was to build this brand with the best karigari. uniquely tailored for each and every individual.`,
                                    image_url: "https://pub-ed4dcf9e4976449fa869f76b2ec53b5d.r2.dev/2023/December/Items/755000925145414500000.jpg",
                                    call_to_action_text: "Shop Now",
                                    call_to_action_link: "shop/products"
                                }, {
                                    title: "IKAKI",
                                    sub_title: `We are situated in Bhopal, which is the birthplace of our founder, Apurvi Vyas. She believed that every individual is ikaki (one of a kind), and that is why her vision was to build this brand with the best karigari. uniquely tailored for each and every individual.`,
                                    image_url: "https://pub-ed4dcf9e4976449fa869f76b2ec53b5d.r2.dev/2023/December/Items/133090442030062700000.jpg",
                                    call_to_action_text: "Shop Now",
                                    call_to_action_link: "shop/products"
                                }, {
                                    title: "IKAKI",
                                    sub_title: `We are situated in Bhopal, which is the birthplace of our founder, Apurvi Vyas. She believed that every individual is ikaki (one of a kind), and that is why her vision was to build this brand with the best karigari. uniquely tailored for each and every individual.`,
                                    image_url: "https://pub-ed4dcf9e4976449fa869f76b2ec53b5d.r2.dev/2023/December/Items/433526511597908400000.jpg",
                                    call_to_action_text: "Shop Now",
                                    call_to_action_link: "shop/products"
                                }]}
                                renderItem={({ item, index, animationValue }) => {
                                    return (
                                        <CustomItem
                                            key={index}
                                            index={index}
                                            animationValue={animationValue}
                                            item={item}
                                        />
                                    );
                                }}
                                // customAnimation={animationStyle}
                                scrollAnimationDuration={500}
                            />
                        </View>
                    </View>

                    {/* features cards--------- */}

                    <View style={{
                        // flexBasis: '100%'
                    }}>

                        <View center marginB-50 marginT-50>
                            <Text CormoRegular style={{
                                // fontFamily: 'Sen_700Bold',
                                letterSpacing: 1,
                                fontSize: 38
                            }}>FEATURED PRODUCTS</Text>
                            <View row style={{
                                position: 'relative',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                marginTop: 20,
                            }}>
                                <View style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: 10,
                                    backgroundColor: 'tan',
                                    zIndex: 2,
                                }}></View>
                                <View style={{
                                    width: '50%',
                                    height: 1,
                                    backgroundColor: 'tan',
                                    zIndex: 1,
                                }}></View>
                                <View style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: 10,
                                    backgroundColor: 'tan',
                                    zIndex: 2,
                                }}></View>
                            </View>
                        </View>


                        <View center marginT-20 marginB-50>
                            <TouchableOpacity onPress={() => {
                                navigationFn("shop/products", {});
                            }} style={{
                                backgroundColor: '#fff',
                                border: '2px solid #cab78d',
                                color: '#cab78d',
                                padding: 10,
                                width: isDesktop ? 200 : '100%',
                                alignItems: 'center',
                                paddingVertical: 10,
                                paddingHorizontal: 30,
                            }}
                            ><Text>View All</Text></TouchableOpacity>
                        </View>
                    </View>

                    <View style={{
                        backgroundImage: 'url(https://static.wixstatic.com/media/168a64_56d782689bb3496eb8edcdb446dffe4e~mv2.jpeg/v1/fill/w_2002,h_1019,al_c,q_90,enc_auto/168a64_56d782689bb3496eb8edcdb446dffe4e~mv2.jpeg)',
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        width: '100%',
                        height: 800,
                    }}>
                        <View style={{ flex: 1, justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Text PoppinsLight style={{ marginBottom: 20, fontSize: 50, textAlign: 'center', color: '#000000' }}>Recycled Sterling Silver</Text>
                            <Text PoppinsExtraLight style={{ marginBottom: 10, fontSize: 36, textAlign: 'center', color: '#000000' }}>24K Gold Plated</Text>
                            <TouchableOpacity style={{
                                marginTop: 15,
                                marginBottom: 25,
                                backgroundColor: '#000000',
                                paddingVertical: 10,
                                paddingHorizontal: 20,
                                width: 200
                            }}>
                                <Text PoppinsExtraLight style={{
                                    color: '#FFFFFF',
                                    fontSize: 16,
                                    textAlign: 'center'
                                }}>SHOP</Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View style={{
                        overflow: 'hidden'
                    }}>

                        <View row style={{
                            flexWrap: 'wrap',
                        }}>
                            <View flex center style={{
                                flexBasis: isDesktop ? '50%' : '100%',
                                padding: 0,
                                position: "relative",
                                height: isDesktop ? '70vh' : 400,
                                justifyContent: 'start',
                                paddingTop: 22
                            }}>
                                <Image source={{ uri: 'https://static.wixstatic.com/media/168a64_82ae5131d9a643ebba01733710f86cad~mv2.jpg/v1/fill/w_1470,h_1176,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/168a64_82ae5131d9a643ebba01733710f86cad~mv2.jpg' }} style={{
                                    width: '100%',
                                    height: isDesktop ? '70vh' : 400,
                                    objectFit: 'cover',
                                    position: "absolute",
                                    left: 0,
                                    top: 0
                                }} />
                                <Text PoppinsLight style={{
                                    fontSize: 18,
                                    marginTop: 8,
                                    color: '#000000',
                                }}>NECKLACES</Text>
                                <TouchableOpacity style={{
                                    backgroundColor: '#000000',
                                    paddingVertical: 8,
                                    paddingHorizontal: 16,
                                    borderRadius: 4,
                                    marginTop: 12,
                                }}>
                                    <Text PoppinsExtraLight style={{
                                        color: '#FFFFFF',
                                        fontSize: 14,
                                        fontWeight: 'bold',
                                    }}>SHOP NOW</Text>
                                </TouchableOpacity>
                            </View>
                            <View flex center style={{
                                flexBasis: isDesktop ? '50%' : '100%',
                                padding: 0,
                                height: isDesktop ? '70vh' : 400,
                                justifyContent: 'start',
                                paddingTop: 22
                            }}>
                                <Image source={{ uri: 'https://static.wixstatic.com/media/168a64_7af43a89b7a04d3cbc10c78a06abbcb7~mv2.png/v1/fill/w_1470,h_1176,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/168a64_7af43a89b7a04d3cbc10c78a06abbcb7~mv2.png' }} style={{
                                    width: '100%',
                                    height: isDesktop ? '70vh' : 400,
                                    objectFit: 'cover',
                                    position: "absolute",
                                    left: 0,
                                    top: 0
                                }} />
                                <Text PoppinsLight style={{
                                    fontSize: 18,
                                    marginTop: 8,
                                    color: '#000000',
                                }}>BRACELETS</Text>
                                <TouchableOpacity style={{
                                    backgroundColor: '#000000',
                                    paddingVertical: 8,
                                    paddingHorizontal: 16,
                                    borderRadius: 4,
                                    marginTop: 12,
                                }}>
                                    <Text PoppinsExtraLight style={{
                                        color: '#FFFFFF',
                                        fontSize: 14,
                                    }}>SHOP NOW</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                        <View row style={{
                            flexWrap: 'wrap',
                        }}>
                            <View flex center style={{
                                flexBasis: isDesktop ? '50%' : '100%',
                                padding: 0,
                                position: "relative",
                                height: isDesktop ? '70vh' : 400,
                                justifyContent: 'start',
                                paddingTop: 22
                            }}>
                                <Image source={{ uri: 'https://static.wixstatic.com/media/168a64_82ae5131d9a643ebba01733710f86cad~mv2.jpg/v1/fill/w_1470,h_1176,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/168a64_82ae5131d9a643ebba01733710f86cad~mv2.jpg' }} style={{
                                    width: '100%',
                                    height: isDesktop ? '70vh' : 400,
                                    objectFit: 'cover',
                                    position: "absolute",
                                    left: 0,
                                    top: 0
                                }} />
                                <Text PoppinsLight style={{
                                    fontSize: 18,
                                    marginTop: 8,
                                    color: '#000000',
                                }}>NECKLACES</Text>
                                <TouchableOpacity style={{
                                    backgroundColor: '#000000',
                                    paddingVertical: 8,
                                    paddingHorizontal: 16,
                                    borderRadius: 4,
                                    marginTop: 12,
                                }}>
                                    <Text PoppinsExtraLight style={{
                                        color: '#FFFFFF',
                                        fontSize: 14,
                                    }}>SHOP NOW</Text>
                                </TouchableOpacity>
                            </View>
                            <View flex center style={{
                                flexBasis: isDesktop ? '50%' : '100%',
                                padding: 0,
                                height: isDesktop ? '70vh' : 400,
                                justifyContent: 'start',
                                paddingTop: 22
                            }}>
                                <Image source={{ uri: 'https://static.wixstatic.com/media/168a64_7af43a89b7a04d3cbc10c78a06abbcb7~mv2.png/v1/fill/w_1470,h_1176,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/168a64_7af43a89b7a04d3cbc10c78a06abbcb7~mv2.png' }} style={{
                                    width: '100%',
                                    height: isDesktop ? '70vh' : 400,
                                    objectFit: 'cover',
                                    position: "absolute",
                                    left: 0,
                                    top: 0
                                }} />
                                <Text PoppinsLight style={{
                                    fontSize: 18,
                                    marginTop: 8,
                                    color: '#000000',
                                }}>BRACELETS</Text>
                                <TouchableOpacity style={{
                                    backgroundColor: '#000000',
                                    paddingVertical: 8,
                                    paddingHorizontal: 16,
                                    borderRadius: 4,
                                    marginTop: 12,
                                }}>
                                    <Text PoppinsExtraLight style={{
                                        color: '#FFFFFF',
                                        fontSize: 14,
                                    }}>SHOP NOW</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </View>

                    {/* <View row style={{
                        flexWrap: 'wrap',
                        paddingHorizontal: 4,
                    }}>
                        {[
                            `https://pub-ed4dcf9e4976449fa869f76b2ec53b5d.r2.dev/2023/December/Items/698628237260366800000.jpg`,
                            "https://pub-ed4dcf9e4976449fa869f76b2ec53b5d.r2.dev/2023/December/Items/646209661215470300000.jpg",
                            "https://pub-ed4dcf9e4976449fa869f76b2ec53b5d.r2.dev/2023/December/Items/617292830181685600000.jpg",
                            "https://pub-ed4dcf9e4976449fa869f76b2ec53b5d.r2.dev/2023/December/Items/582913415391504960000.jpg"
                        ].map((el, index) => <View key={el} style={{
                            flexBasis: isDesktop ? '25%' : '50%',
                            paddingHorizontal: 4,
                        }}>
                            <View style={{
                                width: '100%',
                                border: '3px solid #fff',
                                position: 'relative',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                                <Image resizeMode="cover" source={{ uri: el }}
                                    style={isDesktop ? { width: '100%', height: 400 } : { width: '100%', height: 300 }} />
                            </View>
                            <View center style={{
                                position: 'absolute',
                                bottom: 25,
                                width: '100%',
                            }}>
                                <TouchableOpacity activeOpacity={0.9} onPress={() => {

                                }}
                                >
                                    <View paddingH-50 backgroundColor={"tan"}>
                                        <Text style={{ color: 'white', fontFamily: 'Sen_700Bold', padding: 10 }}>
                                            {index == 0 && "Lehengas"}
                                            {index == 1 && "Kurta Sets"}
                                            {index == 2 && "Coords"}
                                            {index == 3 && "Dresses"}
                                        </Text>
                                    </View>
                                </TouchableOpacity>
                            </View>
                        </View>)}
                    </View> */}

                    <View row marginT-80 marginV-50 flex style={{
                        flexWrap: 'wrap',
                        paddingHorizontal: 4
                    }}>
                        <View padding-4 style={{
                            flexBasis: isDesktop ? '25%' : '50%',
                        }}>
                            <View flexG paddingH-30 paddingV-25 style={{
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#fffbf2',
                                height: '140px',
                                borderWidth: 2,
                                borderColor: '#cab78d5c',
                            }} >
                                <View>
                                    {boxIcon({ width: 50, height: 50, fill: '#000', })}
                                </View>
                                <View >
                                    <Text style={{
                                        textAlign: 'center',
                                        fontFamily: 'Sen_700Bold',
                                    }}>FREE DELIVERY</Text>
                                </View>
                                <View >
                                    <Text style={{
                                        textAlign: 'center',
                                    }}>
                                        For all orders over $120
                                    </Text>
                                </View>
                            </View>
                        </View>

                        <View padding-4 style={{
                            flexBasis: isDesktop ? '25%' : '50%',
                        }}>
                            <View flexG paddingH-30 paddingV-25 style={{
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#fffbf2',
                                height: '140px',
                                borderWidth: 2,
                                borderColor: '#cab78d5c',
                            }} >
                                <View>
                                    {paymentIcon({ width: 40, height: 40 })}
                                </View>
                                <View >
                                    <Text style={{
                                        textAlign: 'center',
                                        fontFamily: 'Sen_700Bold',
                                    }}>SECURE PAYMENTS</Text>
                                </View>
                                <View>
                                    <Text style={{
                                        textAlign: 'center',
                                    }}>Accept all payment methods</Text>
                                </View>
                            </View>
                        </View>

                        <View padding-4 style={{
                            flexBasis: isDesktop ? '25%' : '50%',
                        }}>
                            <View flexG paddingH-30 paddingV-25 style={{
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#fffbf2',
                                height: '140px',
                                borderWidth: 2,
                                borderColor: '#cab78d5c',
                            }} >
                                <View>
                                    {returnIcon({ width: 40, height: 40 })}
                                </View>
                                <View >
                                    <Text style={{
                                        fontFamily: 'Sen_700Bold',
                                        textAlign: 'center',
                                    }}>SATISFACTION ASSURED</Text>
                                </View>
                                <View >
                                    <Text style={{
                                        textAlign: 'center',
                                    }}>Free returns within 14 days</Text>
                                </View>
                            </View>
                        </View>

                        <View padding-4 style={{
                            flexBasis: isDesktop ? '25%' : '50%',
                        }}>
                            <View flexG paddingH-30 paddingV-25 style={{
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#fffbf2',
                                height: '140px',
                                borderWidth: 2,
                                borderColor: '#cab78d5c',
                            }} >
                                <View>
                                    {returnIcon({ width: 40, height: 40 })}
                                </View>
                                <View >
                                    <Text style={{
                                        fontFamily: 'Sen_700Bold',
                                        textAlign: 'center',
                                    }}>SATISFACTION ASSURED</Text>
                                </View>
                                <View>
                                    <Text style={{
                                        textAlign: 'center',
                                    }}>Free returns within 14 days</Text>
                                </View>
                            </View>
                        </View>

                    </View>

                    {/* features cards--------- */}

                    <View style={{
                    }}>

                        <View center marginB-50 marginT-50>
                            <Text CormoRegular style={{
                                // fontFamily: 'Sen_700Bold',
                                letterSpacing: 1,
                                fontSize: 38
                            }}>NEW ARRIVALS</Text>
                            <View row style={{
                                position: 'relative',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                marginTop: 20,
                            }}>
                                <View style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: 10,
                                    backgroundColor: 'tan',
                                    zIndex: 2,
                                }}></View>
                                <View style={{
                                    width: '50%',
                                    height: 1,
                                    backgroundColor: 'tan',
                                    zIndex: 1,
                                }}></View>
                                <View style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: 10,
                                    backgroundColor: 'tan',
                                    zIndex: 2,
                                }}></View>
                            </View>
                        </View>

                        {/* a line more than featured products heading with two dots on both sides */}



                        {/* <FlashList
                            data={products}
                            numColumns={isDesktop ? 4 : 2}
                            estimatedItemSize={170}
                            renderItem={({ item }) => ()}
                            keyExtractor={(item) => item._id}
                        /> */}

                        {/* <Carousel
                            loop={true}
                            autoPlay={true}
                            autoPlayInterval={5000}
                            style={{ width: '100%', height: 420 }}
                            width={(PAGE_WIDTH / 4) - 50}
                            data={products}
                            renderItem={({ item, index, animationValue }) => {
                                return (
                                    
                                );
                            }}
                            // customAnimation={animationStyle}
                            scrollAnimationDuration={500}
                        /> */}

                        <View center marginT-20 marginB-50>
                            <TouchableOpacity onPress={() => {
                                // /shop/products
                                navigationFn("shop/products", {});
                            }} style={{
                                backgroundColor: '#fff',
                                border: '2px solid #cab78d',
                                color: '#cab78d',
                                padding: 10,
                                width: isDesktop ? 200 : '100%',
                                alignItems: 'center',
                                paddingVertical: 10,
                                paddingHorizontal: 30,
                            }}
                            ><Text>View All</Text></TouchableOpacity>
                        </View>
                    </View>

                    {/* <View row style={{
                        flexWrap: 'wrap',
                    }}>
                        <View style={{
                            flexBasis: isDesktop ? '50%' : '100%',
                            padding: 4
                        }}>
                            <View style={{
                                width: '100%'
                            }}>
                                <View>
                                    <View style={{
                                        position: 'relative',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}>
                                        <Image source={{ uri: `https://apiserver.seasonsindia.com/uploads/feature_images/11692101.jpg` }}
                                            style={{ width: '100%', height: isDesktop ? '90vh' : 400 }} />

                                        <View marginB-0 style={{
                                            position: 'absolute',
                                            bottom: 35,
                                            left: 35,
                                        }}>
                                            <View>
                                                <Text style={{
                                                    color: '#fff',
                                                    fontSize: 24,
                                                    textTransform: 'uppercase',
                                                }}>Just In</Text>
                                            </View>
                                            <View marginB-15>
                                                <Text style={{
                                                    color: '#fff',
                                                    fontSize: 40,
                                                    fontFamily: 'Sen_700Bold'
                                                }}>25% OFF</Text>
                                            </View>

                                            <TouchableOpacity onPress={() => {
                                                // navigationFn("hrms/attendanceRegister", {});
                                            }}
                                                style={{
                                                    backgroundColor: 'none',
                                                    border: '2px solid #fff',
                                                    color: '#fff',
                                                    paddingHorizontal: 30,
                                                    paddingVertical: 15,
                                                    // width: '100%',
                                                    alignItems: 'center'
                                                }}>
                                                <Text style={{ color: '#fff' }}>
                                                    Shop Now
                                                </Text>
                                            </TouchableOpacity>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={{
                            flexBasis: isDesktop ? '50%' : '100%',
                            padding: 4
                        }}>
                            <View style={{
                                width: '100%'
                            }}>
                                <View>
                                    <View style={{
                                        position: 'relative',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}>
                                        <Image source={{ uri: `https://apiserver.seasonsindia.com/uploads/feature_images/11692101.jpg` }}
                                            style={{ width: '100%', height: isDesktop ? '90vh' : 400 }} />

                                        <View marginB-0 style={{
                                            position: 'absolute',
                                            bottom: 35,
                                            left: 35,
                                        }}>
                                            <View>
                                                <Text style={{
                                                    color: '#fff',
                                                    fontSize: 24,
                                                    textTransform: 'uppercase',
                                                }}>Just In</Text>
                                            </View>
                                            <View marginB-15>
                                                <Text style={{
                                                    color: '#fff',
                                                    fontSize: 40,
                                                    fontFamily: 'Sen_700Bold'
                                                }}>25% OFF</Text>
                                            </View>

                                            <TouchableOpacity onPress={() => {
                                                // navigationFn("hrms/attendanceRegister", {});
                                            }}
                                                style={{
                                                    backgroundColor: 'none',
                                                    border: '2px solid #fff',
                                                    color: '#fff',
                                                    paddingHorizontal: 30,
                                                    paddingVertical: 15,
                                                    // width: '100%',
                                                    alignItems: 'center'
                                                }}>
                                                <Text style={{ color: '#fff' }}>Shop Now</Text>
                                            </TouchableOpacity>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View> */}


                    {/* extra offer--------- */}

                    <View backgroundColor="white">
                        <View paddingH-20 row>
                            <Col noGutter={true} width="100%">
                                <iframe src="https://widget.taggbox.com/144573"
                                    style={{
                                        width: '100%',
                                        border: 'none',
                                        height: '600px',
                                        overflow: 'hidden',
                                    }}
                                ></iframe>
                            </Col>
                        </View>
                    </View>

                    {/* Footer--------- */}

                </View>

                <Footer />
            </Card>
        </ScrollView>
    </>)
})

export default Home

const CustomItem = ({ index, animationValue, item }) => {
    const maskStyle = useAnimatedStyle(() => {
        const backgroundColor = interpolateColor(
            animationValue.value,
            [-1, 0, 1],
            ["#000000dd", "transparent", "#000000dd"],
        );

        return {
            backgroundColor,
        };
    }, [animationValue]);

    return (
        <View style={{ flex: 1 }}>
            <SBItem key={index} index={index} style={{ borderRadius: 0 }} item={item} />
            <Animated.View
                pointerEvents="none"
                style={[
                    {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                    },
                    maskStyle,
                ]}
            />
        </View>
    );
};

const SBItem = (props) => {
    const { style, index, pretty, testID, item, ...animatedViewProps } = props;
    const enablePretty = false;
    const [isPretty, setIsPretty] = React.useState(pretty || enablePretty);

    return (
        <LongPressGestureHandler
            onActivated={() => {
                setIsPretty(!isPretty);
            }}
        >
            <Animated.View testID={testID} style={{ flex: 1 }} {...animatedViewProps}>
                <SBImageItem style={style} index={index} showIndex={typeof index === "number"} item={item} />
            </Animated.View>
        </LongPressGestureHandler>
    );
};

const SBImageItem = ({ style, index: _index, showIndex = true, item }) => {
    let navigation = useNavigation();
    let navigate = null;

    if (Platform.OS === 'web') {
        navigate = useNavigate();
    }

    const navigationFn = (path, params) => {
        if (Platform.OS === 'web') {
            let paramsString = "";
            if (params) {
                paramsString = "?" + Object.keys(params).map(key => key + '=' + params[key]).join('&');
            }
            navigate("/" + path + paramsString);
        } else {
            if (path.includes("report/")) {
                navigation.navigate("report", {
                    ...params,
                    name: path.replace("report/", ""),
                });
            } else {
                navigation.navigate(path, params);
            }
        }
    };


    const index = (_index || 0) + 1;
    const source = React.useRef({
        uri: item.image_url,
    }).current;

    return (
        <View style={[{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#fff",
            borderRadius: 8,
            overflow: "hidden",
        }, style]}>
            <Image key={index} style={{
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
            }} source={{
                uri: item.image_url,
            }} />
            <View style={{
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "black",
                opacity: 0.5,
            }}>
            </View>

            <View
                centerV
                style={{
                    width: PAGE_WIDTH,
                    height: isDesktop ? Dimensions.get("window").height : 600,
                    zIndex: 2,
                    padding: isDesktop ? 50 : 20,
                    marginTop: isDesktop ? 0 : 0,
                }}
            >
                <View center style={{
                    marginTop: 'auto'
                }}>
                    <Text style={{
                        color: "#fff",
                        fontSize: 40,
                        fontWeight: "bold",
                        fontFamily: "Sen_700Bold",
                        letterSpacing: 0.6
                    }}>
                        {item.title}
                    </Text>

                    <View marginT-5 style={{
                        maxWidth: isDesktop ? "80%" : "90%",
                    }}>
                        <Text center style={{
                            color: "#fff",
                            fontSize: 13,
                            fontFamily: "Sen_400Regular",
                            letterSpacing: 0.6,
                            lineHeight: 20,
                            textAlign: "center"
                        }}>
                            {item.sub_title}
                        </Text>
                    </View>

                    <TouchableOpacity
                        onPress={() => {
                            navigationFn(item.call_to_action_link, {});
                        }}
                        style={{
                            backgroundColor: 'none',
                            border: '2px solid #fff',
                            color: '#fff',
                            paddingHorizontal: 30,
                            paddingVertical: 15,
                            // width: '100%',
                            alignItems: 'center',
                            marginTop: 20,
                        }}>
                        <Text style={{ color: '#fff' }}>
                            {item.call_to_action_text}
                        </Text>
                    </TouchableOpacity>
                </View>
            </View>
        </View>
    );
};

const SBTextItem = ({ style, index }) => {
    return (
        <View style={[{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#fff",
            borderRadius: 8,
        }, style]}>
            <Image style={{
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
            }} source={{ uri: `https://picsum.photos/id/${index}/1920/1080` }} />
        </View>
    );
}

export const ProductCard = ({ navigationFn, item }) => {
    return <TouchableOpacity
        style={{
            width: "100%"
        }}
        onPress={() => {
            navigationFn("shop/product/" + item.sku + "/" + item._id)
        }}>
        <View style={{
            width: '100%',
            position: 'relative',
            justifyContent: 'center',
            alignItems: 'center',
            paddingHorizontal: 5
        }}>
            <Image resizeMode="cover" source={{
                uri: item.image_urls[0] ? item.image_urls[0]?.url : "https://www.thermaxglobal.com/wp-content/uploads/2020/05/image-not-found.jpg"
            }}
                style={{ width: '100%', height: 380 }} />

            <View marginT-10 marginB-20 paddingH-5 style={{
                backgroundColor: '#fff',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                width: '100%',
            }}>
                <View center style={{
                    width: '100%',
                }}>
                    <Text style={{
                        fontSize: 15,
                        fontFamily: 'Sen_700Bold',
                        textAlign: 'center',
                    }}>{item.name}</Text>

                    <View style={{
                        height: 1,
                        width: 30,
                        backgroundColor: 'tan',
                        marginVertical: 5
                    }}>
                    </View>
                    <View marginT-5 row center>
                        <Text style={{ fontSize: 13 }}>Rs. {item.sales_rate}</Text>
                        {item.mrp && item.mrp != item.sales_rate && (<>
                            <Text style={{ fontSize: 13, marginLeft: 4, textDecorationLine: 'line-through', textDecorationStyle: 'solid' }}>Rs. {item.mrp}</Text>
                            {/* <Text style={{ fontSize: 13, marginLeft: 4 }}>({15}% Off)</Text> */}
                            <Text style={{ fontSize: 13, marginLeft: 4 }}>({(Math.round((item.mrp - item.sales_rate) / item.mrp * 100).toFixed(2))}% Off)</Text>
                        </>)}
                    </View>
                    <TouchableOpacity
                        style={{
                            width: '100%',
                            marginTop: 10,
                        }}
                        onPress={() => {
                            navigationFn("shop/product/" + item.sku + "/" + item._id)
                        }}>
                        <View center backgroundColor={"white"} style={{
                            width: '100%',
                            borderWidth: 1,
                            borderColor: 'black',
                        }}>
                            <Text style={{ color: 'black', fontFamily: 'Sen_400Regular', padding: 10, letterSpacing: 0.4, fontSize: 12 }}>
                                SHOP NOW
                            </Text>
                        </View>
                    </TouchableOpacity>
                </View>
            </View>
        </View>
    </TouchableOpacity>
}
